<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #282828;
	margin: 0!important;
	padding: 0!important;
	background: #f2f2f8;
}
body{
	margin: 0;
 	padding: 0;
  min-width:1440px;
  overflow:auto;
}
@media(max-width:768px){
  body{
	margin: 0;
 	padding: 0;
  min-width:100%;
  overflow:auto;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue